import { Module } from 'vuex';
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import { serializer } from '../../api/shared/serializer';
import moment from "moment";

const galleryModule: Module<any, any> = {
  namespaced: false,
  state: {
    photos: [],
    currentPhoto: null,
    eventPicturesTime: {
      start: null,
      end: null
    },
    galleryFolders: [],
    galleryFolderPhotos: []
  },

  mutations: {
    setPhotos(state: any, payload: []) {
      state.photos = payload;
    },

    setPhoto(state: any, payload: null) {
      state.currentPhoto = payload;
    },

    setEventPicturesTime(state: any, payload) {
      state.eventPicturesTime.start = payload.start;
      state.eventPicturesTime.end = payload.end;
    },

    setGalleryFolders(state: any, payload) {
      state.galleryFolders = payload;
    },

    setGalleryFolderPhotos(state: any, payload) {
      state.galleryFolderPhotos = payload;
    }
  },

  actions: {
    async getFacilityPhotos({ commit }, {startDate , endDate}) {
      const items = firebase
        .firestore()
        .collection('photos')
        .where('facilityId', '==', this.state.authModule.currentFacility)
        .where('isStaff', '==', true)
        .where('createdAt', '>=',  moment(startDate).startOf('day').unix() * 1000)
        .where('createdAt','<=',  moment(endDate).endOf('day').unix() * 1000)
        .orderBy("createdAt", "desc");


      await items.get().then(querySnapshot => {
        
        const deviceList = querySnapshot.docs.map(device => {
          const data = device.data();
            const createdAt = !data.createdAt
            ? null
            : moment(data.createdAt).toDate();

          data.createdAt = createdAt;
          data.id = device.id;
          return {
            ...data
          };
        }).filter(x => !x.folderId)
          .filter(x => !x.isStock)

        commit(
          'setPhotos',
          deviceList
        );
      });
    },

    async getPhoto({ commit }, id) {
      const items = firebase
        .firestore()
        .collection('photos')
        .doc( id);

      await items.get().then(querySnapshot => {

        commit(
          'setPhoto',
          serializer.documentSnapshotToDocument<any>(querySnapshot)
        );
      });
    },

    async getGalleryFolders({ commit }) {
      await firebase
        .firestore()
        .collection("galleryFolders")
        .where("facilityId", "==", this.state.authModule.currentFacility)
        .get()
        .then(async (data) => {
          const folders: any[] = serializer.querySnapshotToDocuments(data)
            .sort((a: any, b: any) => moment(a.createdAt.seconds * 1000).diff(moment(b.createdAt.seconds * 1000)));

          for(let i = 0; i < folders.length; i++) {
            await firebase
              .firestore()
              .collection("photos")
              .where("facilityId", "==", this.state.authModule.currentFacility)
              .where("folderId", "==", folders[i].id)
              .orderBy('createdAt', 'desc')
              .limit(1)
              .get()
              .then((data: any) => {
                const result: any = serializer.querySnapshotToDocuments(data)[0];
                folders[i].image = result?.image ? result?.image : require("../../assets/no-image.jpg");
              })
          }

          commit('setGalleryFolders', folders)
        })
    },

    async getGalleryFolderPhotos({ commit }, folderId) {
      await firebase
        .firestore()
        .collection("photos")
        .where("facilityId", "==", this.state.authModule.currentFacility)
        .where("folderId", "==", folderId)
        .get()
        .then((data) => {
          const result = serializer.querySnapshotToDocuments(data).sort((a: any, b: any) => moment(b.createdAt).diff(moment(a.createdAt)));
          commit("setGalleryFolderPhotos", result)
        })
    }


    // async addContent({ commit }, content: any) {
    //   if (!content) return;

    //   const db = firebase.firestore();
    //   content.facilityId = this.state.authModule.currentFacility;
    //   content.createdByStaffId = this.state.authModule.user.id;
    //   content.createdByStaffName = this.state.authModule.user.name;
    //   content.dateTimeCreated = firebase.firestore.Timestamp.fromDate(
    //     new Date()
    //   );

    //   return await db.collection('contentLibrary').add(content);
    // },

    // async deleteContent({ commit }, media: any) {

    //   if (!media) return

    //   //folder with files are removing on the trigger side
    //   return await firebase.firestore().collection("contentLibrary").doc(media.id).delete().then(() => {
    //     console.log('media deleted')
    //   })

    // },

  }
};
export default galleryModule;
